<app-terminal-overlay
    [title]="title()"
    subtitle="{{ 'GENERAL.SUBTITLE.SELECT_AMOUNT' | translate }}"
    [activityType]="activityType()"
    [measurementType]="activity()?.measurementType"
    icon="fa-boxes-stacked"
    (closeRequested)="onCloseRequested()"
    (finishRequested)="onFinishRequested()"
>
    <app-amount-result
        (amountResultUpdated)="onAmountResultUpdated($event)"
        [activityAndAmountResult]="{ activity: activity(), amountResult: amountResultInput }"
    />

    <app-manual-flow-footer
        data-footer
        (cancel)="onCloseRequested()"
        (next)="onSelectionComplete()"
        [nextEnabled]="amountResultInput !== undefined"
        [cancelEnabled]="true"
    />
</app-terminal-overlay>
